import {
    Box,
    FormControl,
    InputLabel,
    InputProps,
    OutlinedInput,
    Typography,
} from "@mui/material";

export default function InputField(
    props: InputProps & {
        label?: string;
        sublabel?: string;
        customwidth?: string;
        customHeight?: string;
        customMarginBottomLabel?: {
            xs?: string | number;
            sm?: string | number;
            md?: string | number;
            lg?: string | number;
            xl?: string | number;
        };
        fontSize?: string;
        outlinedinputsx?: object;
        errortext?: string;
    }
) {
    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                gap: "0.5rem",
                width: "100%",
            }}
        >
            <InputLabel
                sx={{
                    fontSize: "0.875rem",
                    fontFamily: "Roboto",

                    color: "#023",
                    fontStyle: "normal",
                    fontWeight: "500",
                    lineHeight: "160%",
                }}
            >
                {props.label}
            </InputLabel>
            {props.sublabel ? (
                <Typography
                    sx={{
                        color: "#023",
                        fontFamily: "Roboto",
                        fontSize: "0.75rem",
                        fontStyle: "normal",
                        fontWeight: 300,
                        lineHeight: "normal",
                    }}
                >
                    {props.sublabel}
                </Typography>
            ) : null}
            <FormControl
                fullWidth={props.fullWidth ?? false}
                variant="standard"
                error={props.error}
            >
                <OutlinedInput
                    fullWidth={props.fullWidth ?? false}
                    {...props}
                    sx={{
                        ".css-17cvodc-MuiInputBase-input-MuiOutlinedInput-input":
                            {
                                padding: "1.0625rem 1rem",
                            },
                        display: "flex",
                        flex: "1 0 0",
                        alignItems: "center",
                        gap: "0.5rem",
                        alignSelf: "stretch",
                        borderRadius: "1rem",
                        background: "#FFF",
                        "& .MuiOutlinedInput-notchedOutline": {
                            border: "none",
                        },
                        ...props.outlinedinputsx,
                    }}
                />
            </FormControl>
            {props.errortext ? (
                <Typography
                    sx={{
                        fontSize: {
                            xs: "15px",
                            md: "17px",
                        },
                        fontWeight: "600",
                        fontFamily: "Roboto",
                        marginBottom: "10px",
                    }}
                    color="#E51846"
                >
                    {props?.errortext ?? ""}
                </Typography>
            ) : null}
        </Box>
    );
}
